var render = function render(){var _vm=this,_c=_vm._self._c;return (['HsyDemo','MonitoringVideoPlayback','FlvDemo'].includes(_vm.$route.name))?_c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1)],1):_c('div',{attrs:{"id":"app"}},[_c('Ceiling'),_c('keep-alive',[_c('router-view')],1),_c('Bottom'),_c('LinkUs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }